module.exports = __webpack_public_path__ + "img/wave-resilience.ade84b52.png";